module.exports = __webpack_public_path__ + "img/2.2134b6ae.jpeg";